import { outreachStatus } from '@/constants/outreach-status';
import { KText } from '@/ui-library/components';
import { Box, Center, Flex } from '@chakra-ui/react';
import { Send01 } from '@kula-ai/icons-core';
import { FlowItem as FlowItemType } from '../../types';
// import { SearchItemWrapper } from './SearchItemWrapper';
import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react';
// import { useSearchManager } from '../search-manager';
// import { HighlightedTooltipText } from '../text';

interface FlowItemProps {
  item: FlowItemType;
  isSelected?: boolean;
  onSearchClose?: () => void;
}

export const FlowItem = ({
  item,
  isSelected,
  onSearchClose,
}: FlowItemProps) => {
  const itemRef = useRef<HTMLAnchorElement>(null);
  const { title, status, id } = item;
  const statusColor =
    status === 'active'
      ? '#73D017'
      : outreachStatus?.[status]?.color || 'pastel-2-dark';

  useEffect(() => {
    if (isSelected && itemRef.current) {
      itemRef.current.scrollIntoView({ block: 'nearest' });
    }
  }, [isSelected]);

  return (
    <Link
      to={`/outreaches/${id}`}
      style={{ textDecoration: 'none' }}
      ref={itemRef}
      onClick={() => onSearchClose?.()}
    >
      <Flex
        alignItems="center"
        gap="12px"
        className="ai-search-flow-item"
        p="12px"
        _hover={{
          backgroundColor: 'secondary-50',
        }}
        backgroundColor={isSelected ? 'secondary-50' : undefined}
      >
        <Center
          width="36px"
          height="36px"
          borderRadius="xs"
          bg="pastel-2-light"
        >
          <Send01
            size="1rem"
            color="var(--kula-colors-pastel-2-dark)"
            className="kula-icon"
          />
        </Center>
        <KText variant="heading_3" color="secondary-900">
          {title}
        </KText>
        <KText
          variant="paragraph"
          color="secondary-700"
          p="1px 8px"
          borderRadius="xs"
          border="1px solid"
          borderColor="secondary-100"
          textTransform="capitalize"
          display="flex"
          alignItems="center"
          gap="4px"
          lineHeight="20px"
          ml="-6px"
        >
          <Box bg={statusColor} borderRadius="full" w="8px" h="8px" />
          {status}
        </KText>
      </Flex>
    </Link>
  );
};
